import { useMemo } from "react"
import { colors, css, fonts, glyphs } from "../../Styles"

interface cardNumberDisplay_Props {
  header?: string
  value: number | string
  unit: string
  glyph: JSX.Element
}
/**
 * NumberDisplay
 * @param header header to display above the single numberDisplay component.
 * @param value the value of the number to be displayed.
 * @param unit the unit of the value.
 * @returns a nice way to display a value/number. 
 */
export default function CardNumberDisplay ({header, value, unit, glyph}:cardNumberDisplay_Props) {

  return (
    <div style={{ position: "relative", backgroundColor: colors.greyPrimary, borderRadius: "10px", width: "155px", height: "70px", display: "flex", alignItems: "center", justifyContent: "center"}}>
      
      <div style={{zIndex: "1", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
        <p style={{...fonts.header, ...fonts.fontSize1, color: colors.greyLightTertiary,}}>{value}</p>
        <div style={{ height: "2px", backgroundColor: colors.greySecondary, width: "50px" }}/>
        <p style={{...fonts.header, ...fonts.fontSize4, color: colors.greyTertiary, marginTop: "5px", width: "130px", textAlign: "center", backgroundColor: colors.transparent}}>{unit}</p>
      </div>
      
      <div style={{zIndex: "0", borderRadius: "10px", position: "absolute", width: "155px", height: "70px", overflow: "hidden"}}>
        <div style={{position: "absolute", transform: "translate(-50%, -50%)", top: "50%", left: "50%"}}>
          {glyph}
        </div>
      </div>

    </div>
  )
}
